import { IHealthProblemCoSoItemRequest } from '../../../models/request/y-te/yTeRequests';
import { healthproblem, HealthProblemCoSoItemResponse } from '../../../models/response/y-te/healthproblem';

export enum eHealthProblemActionTypeIds {
	LOAD_START = "HEALTH_PROBLEM_LOAD_START",
	LOAD_SUCCESS = "HEALTH_PROBLEM_LOAD_SUCCESS",
	LOAD_ERROR = "HEALTH_PROBLEM_LOAD_ERROR",

	LOAD_DETAIL_START = "HEALTH_PROBLEM_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "HEALTH_PROBLEM_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "HEALTH_PROBLEM_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "HEALTH_PROBLEM_SHOW_DETAIL",
	CLOSE_DETAIL = "HEALTH_PROBLEM_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "HEALTH_PROBLEM_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "HEALTH_PROBLEM_SHOW_CONFIRM",
	CLOSE_CONFIRM = "HEALTH_PROBLEM_CLOSE_CONFIRM",

	SAVE_START = "HEALTH_PROBLEM_SAVE_START",
	SAVE_SUCCESS = "HEALTH_PROBLEM_SAVE_SUCCESS",
	SAVE_ERROR = "HEALTH_PROBLEM_SAVE_ERROR",

	DELETE_START = "HEALTH_PROBLEM_DELETE_START",
	DELETE_SUCCESS = "HEALTH_PROBLEM_DELETE_SUCCESS",
	DELETE_ERROR = "HEALTH_PROBLEM_DELETE_ERROR",

	SHOW_DANGKY_MODAL = "HEALTH_PROBLEM_SHOW_DANGKY_MODAL",
	CLOSE_DANGKY_MODAL = "HEALTH_PROBLEM_CLOSE_DANGKY_MODAL",

	LOAD_DANGKY_START = "HEALTH_PROBLEM_LOAD_DANGKY_START",
	LOAD_DANGKY_SUCCESS = "HEALTH_PROBLEM_LOAD_DANGKY_SUCCESS",
	LOAD_DANGKY_ERROR = "HEALTH_PROBLEM_LOAD_DANGKY_ERROR",

	CHANGE_DANGKY_DATAS = "HEALTH_PROBLEM_CHANGE_DANGKY_DATAS",

	SAVE_DANGKY_START = "HEALTH_PROBLEM_SAVE_DANGKY_START",
	SAVE_DANGKY_SUCCESS = "HEALTH_PROBLEM_SAVE_DANGKY_SUCCESS",
	SAVE_DANGKY_ERROR = "HEALTH_PROBLEM_SAVE_DANGKY_ERROR"
}

export interface IHealthProblemLoadStart {
	type: eHealthProblemActionTypeIds.LOAD_START,
	payload: number
}
export interface IHealthProblemLoadSuccess {
	type: eHealthProblemActionTypeIds.LOAD_SUCCESS,
	payload: HealthProblemCoSoItemResponse[]
}
export interface IHealthProblemLoadErr {
	type: eHealthProblemActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IHealthProblemLoadDetailStart {
	type: eHealthProblemActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface IHealthProblemLoadDetailSuccess {
	type: eHealthProblemActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: healthproblem
}
export interface IHealthProblemLoadDetailErr {
	type: eHealthProblemActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IHealthProblemShowDetail {
	type: eHealthProblemActionTypeIds.SHOW_DETAIL,
	payload?: healthproblem
}
export interface IHealthProblemCloseDetail {
	type: eHealthProblemActionTypeIds.CLOSE_DETAIL
}
export interface IHealthProblemChangeSelectedIds {
	type: eHealthProblemActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IHealthProblemShowConfirm {
	type: eHealthProblemActionTypeIds.SHOW_CONFIRM
}
export interface IHealthProblemCloseConfirm {
	type: eHealthProblemActionTypeIds.CLOSE_CONFIRM
}
export interface IHealthProblemSaveStart {
	type: eHealthProblemActionTypeIds.SAVE_START,
	payload: healthproblem
}
export interface IHealthProblemSaveSuccess {
	type: eHealthProblemActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IHealthProblemSaveErr {
	type: eHealthProblemActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IHealthProblemDeleteStart {
	type: eHealthProblemActionTypeIds.DELETE_START,
	payload: number
}
export interface IHealthProblemDeleteSuccess {
	type: eHealthProblemActionTypeIds.DELETE_SUCCESS
}
export interface IHealthProblemDeleteErr {
	type: eHealthProblemActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IHealthProblemShowDangKyModal {
	type: eHealthProblemActionTypeIds.SHOW_DANGKY_MODAL
}
export interface IHealthProblemCloseDangKyModal {
	type: eHealthProblemActionTypeIds.CLOSE_DANGKY_MODAL
}
export interface IHealthProblemLoadDangKyStart {
	type: eHealthProblemActionTypeIds.LOAD_DANGKY_START,
	payload: number
}
export interface IHealthProblemLoadDangKySuccess {
	type: eHealthProblemActionTypeIds.LOAD_DANGKY_SUCCESS,
	payload: HealthProblemCoSoItemResponse[]
}
export interface IHealthProblemLoadDangKyErr {
	type: eHealthProblemActionTypeIds.LOAD_DANGKY_ERROR,
	payload: string
}
export interface IHealthProblemChangeDangKyDatas {
	type: eHealthProblemActionTypeIds.CHANGE_DANGKY_DATAS,
	payload: HealthProblemCoSoItemResponse[]
}
export interface IHealthProblemSaveDangKyStart {
	type: eHealthProblemActionTypeIds.SAVE_DANGKY_START,
	payload: IHealthProblemCoSoItemRequest
}
export interface IHealthProblemSaveDangKySuccess {
	type: eHealthProblemActionTypeIds.SAVE_DANGKY_SUCCESS
}
export interface IHealthProblemSaveDangKyErr {
	type: eHealthProblemActionTypeIds.SAVE_DANGKY_ERROR,
	payload: string
}

export type IHealthProblemActionTypes = IHealthProblemLoadStart | IHealthProblemLoadSuccess | IHealthProblemLoadErr |
	IHealthProblemLoadDetailStart | IHealthProblemLoadDetailSuccess | IHealthProblemLoadDetailErr |
	IHealthProblemShowDetail | IHealthProblemCloseDetail |
	IHealthProblemChangeSelectedIds |
	IHealthProblemShowConfirm | IHealthProblemCloseConfirm |
	IHealthProblemSaveStart | IHealthProblemSaveSuccess | IHealthProblemSaveErr |
	IHealthProblemDeleteStart | IHealthProblemDeleteSuccess | IHealthProblemDeleteErr |
	IHealthProblemShowDangKyModal | IHealthProblemCloseDangKyModal |
	IHealthProblemLoadDangKyStart | IHealthProblemLoadDangKySuccess | IHealthProblemLoadDangKyErr |
	IHealthProblemChangeDangKyDatas |
	IHealthProblemSaveDangKyStart | IHealthProblemSaveDangKySuccess | IHealthProblemSaveDangKyErr
